module.exports = __webpack_public_path__ + "static/media/plus_purple.f56a8ace.svg";